export default "__VITE_ASSET__BxLPS_9S__";